import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogCategory from "@/pages/PartsCatalogCategory";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/category/$slug")({
  head: ({ params }) => {
    const name = params.slug.replace(/-/g, ' ');
    return pageHead({ title: `${name} Parts`, description: `Shop ${name} parts and accessories at Rex & Sons RVs.`, path: `/parts-catalog/category/${params.slug}` });
  },
  component: PartsCatalogCategory,
});
